import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLInputElement> {
  static readonly values = {
    key: String,
  };

  declare readonly keyValue: string;
  declare readonly hasKeyValue: boolean;

  toggler: Element | null = null;
  showState: Element | null = null;
  hideState: Element | null = null;
  visibility: boolean = false;

  private _onToggle: (event: Event) => void;

  connect() {
    this.toggler = this._findToggler();
    this.showState = this._findShowState();
    this.hideState = this._findHideState();
    this._onToggle = this._toggle.bind(this);

    this._startToggler();
  }

  disconnect() {
    this._stopToggler();
  }

  private _findToggler() {
    if (!this.hasKeyValue) return null;

    return document.querySelector(`[data-displayable-password-toggler="${this.keyValue}"]`);
  }

  private _findShowState() {
    if (!this.hasKeyValue) return null;

    return document.querySelector(`[data-displayable-password-show="${this.keyValue}"]`);
  }

  private _findHideState() {
    if (!this.hasKeyValue) return null;

    return document.querySelector(`[data-displayable-password-hide="${this.keyValue}"]`);
  }

  private _startToggler() {
    this.toggler?.addEventListener("click", this._onToggle);
  }

  private _stopToggler() {
    this.toggler?.removeEventListener("click", this._onToggle);
  }

  private _toggle(event: Event) {
    event.preventDefault();

    this._setVisibilityState(!this.visibility);
  }

  private _setVisibilityState(visibility: boolean) {
    this.visibility = visibility;

    this.hideState?.classList.toggle("d-none");
    this.showState?.classList.toggle("d-none");
    this.element.type = visibility ? "text" : "password";
  }
}
